export enum TipoCalculoTotalEnum {
        TotalOriginal = 1,
        TotalEscolhido = 2
}